import { Button } from "components";
import { useFormContext } from "react-hook-form";
import { FormType } from "../../schemas";
import toast from "react-hot-toast";
import { useApi } from "utils";
import { useFilterStore } from "../../stores";

export function Create(props: {
    refecth: () => void
    refecthCode: () => void
}) {
    // hooks
    const api = useApi()

    // useForm
    const { handleSubmit, reset } = useFormContext<FormType>();

    // state
    const { filter } = useFilterStore();

    const onSubmit = (data: FormType) => {

        const detailWithMrShift = data.detail
            ?.map(detail => ({
                ...detail,
                shift_schedule: detail.shift_schedule?.filter(
                    shift => Boolean(shift.mr_shift_id)
                )
            }))
            .filter(detail => detail.shift_schedule?.length);

        const finalData = {
            shift_schedule: {
                trx_code: data.code,
                periode_start: filter.date_start,
                periode_end: filter.date_end,
            },
            shift_schedule_detail: detailWithMrShift?.flatMap((item) =>
                item?.shift_schedule?.map((shift) => ({
                    employee_id: Number(item.employee_id),
                    job_position_id: item.job_position_id ? Number(item.job_position_id) : null,
                    divisi_id: item.divisi_id ? Number(item.divisi_id) : null,
                    department_id: item.department_id ? Number(item.department_id) : null,
                    location_id: Number(item.location_id) || 0,
                    date_shift: shift.shift_date,
                    mr_shift_id: shift.mr_shift_id ? Number(shift.mr_shift_id) : 0,
                    in_time: shift.in_time ?? "",
                    out_time: shift.out_time ?? ""
                }))
            )
        };

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/employee/save_data_schedule", finalData),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => {
                        const status = err.response?.status;
                        console.log(status);

                        return (
                            err.response?.data?.detail?.message ||
                            err.response?.data?.message ||
                            err.message ||
                            "Network error"
                        );
                    }
                }
            ).then(() => {
                reset();
                props.refecth();
                props.refecthCode();
            }).catch(() => { }).finally(resolve)
        })
    };

    return (
        <Button
            color="primary"
            onClick={handleSubmit(onSubmit)}
        >
            SUBMIT SCHEDULE
        </Button>
    )
}